import { FeatureService } from 'app/state/feature.service';
import { ActivatedRoute } from '@angular/router';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageText, ToastService } from 'app/helpers/services/toastService';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';
import { RenameTenantMenuItemDto } from 'app/api/models/features/renameTenantMenuItemDto';

@Component({
    selector: 'app-tenant-description-form',
    templateUrl: './tenant-description-form.component.html',
    styleUrl: './tenant-description-form.component.scss',
    standalone: false
})
export class TenantDescriptionFormComponent {
  id: string | null = null;
  itemsToRename: RenameTenantMenuItemDto[] = [];
  form: FormGroup;
  constructor(
    private featuresService: FeatureService,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    public toastService: ToastService,
    public generalDataRepo: GeneralDataRepository,
  ) {
    this.form = this.fb.group({
      customTitle: [''],
      customDescription: [''],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.id = params.get('id');
      if (this.id) {
        this.featuresService.getItemsToRename(this.id).subscribe((features) => {
          this.itemsToRename = features;

          this.itemsToRename.forEach((feature, index) => {
            this.form.addControl(
              `customTitle-${index}`,
              new FormControl(feature.customTitle),
            );
            this.form.addControl(
              `customDescription-${index}`,
              new FormControl(feature.customDescription),
            );
          });

          // PrimeNG's p-editor loads Quill asynchronously and can miss the
          // initial value set when the control is created. Re-apply the
          // description values after the editors have rendered so they show
          // the saved content.
          setTimeout(() => {
            this.itemsToRename.forEach((feature, index) => {
              this.form
                .get(`customDescription-${index}`)
                ?.setValue(feature.customDescription);
            });
          });
        });
      }
    });
  }

  saveChanges(): void {
    if (!this.id) {
      return;
    }

    const updatedFeatures = this.itemsToRename.map((item, index) => ({
      ...item,
      customTitle: this.form.get(`customTitle-${index}`)?.value,
      customDescription: this.form.get(`customDescription-${index}`)?.value,
    }));

    this.featuresService.updateFeatures(this.id, updatedFeatures).subscribe(
      (response) => {
        this.generalDataRepo.updateAllGeneralData(true);
        this.toastService.showSuccess(MessageText.saved);
      },
      (error) => {
        this.toastService.showError(MessageText.updateFeaturesError);
      },
    );
  }
}
